// extracted by mini-css-extract-plugin
export var btnBlock = "ArticleButton-module--btnBlock--72d61";
export var btnPrimary = "ArticleButton-module--btnPrimary--94516";
export var btnSecondary = "ArticleButton-module--btnSecondary--d64a9";